import { render } from "./FilterCounter.vue?vue&type=template&id=4be25420&scoped=true"
import script from "./FilterCounter.vue?vue&type=script&lang=js"
export * from "./FilterCounter.vue?vue&type=script&lang=js"

import "./FilterCounter.vue?vue&type=style&index=0&id=4be25420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be25420"]])

export default __exports__